/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Absences_Edit_EndInputs */

const en_forms_absences_edit_end = /** @type {(inputs: Forms_Absences_Edit_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End`)
};

const de_forms_absences_edit_end = /** @type {(inputs: Forms_Absences_Edit_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ende`)
};

/**
* | output |
* | --- |
* | "End" |
*
* @param {Forms_Absences_Edit_EndInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_absences_edit_end = /** @type {((inputs?: Forms_Absences_Edit_EndInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Absences_Edit_EndInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_absences_edit_end(inputs)
	return de_forms_absences_edit_end(inputs)
});